// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-0483dcac]{display:flex;justify-content:center;align-items:center;padding:.2rem;padding-bottom:.3rem;font-size:.1rem}.footer>p[data-v-0483dcac]{margin-right:3px;color:#bebebe}", ""]);
// Exports
module.exports = exports;
